const PINNED_ANALOGS: Record<string, number[]> = {
  15: [159, 4120],
  25: [159, 4120]
};

const NO_IDS: number[] = [];

export const pinnedAnalogIds = (productId: string | number): number[] =>
  PINNED_ANALOGS[String(productId)] ?? NO_IDS;

export const withPinnedAnalogs = <T extends { id: string }>(
  analogs: T[],
  pinned: T[],
  ids: number[]
): T[] => {
  const byId = new Map<string, T>();
  pinned.forEach(item => byId.set(String(item.id), item));
  const inserted = ids
    .map(id => byId.get(String(id)))
    .filter((item): item is T => item !== undefined);
  if (!inserted.length) {
    return analogs;
  }
  const insertedIds = new Set(inserted.map(item => String(item.id)));
  const rest = analogs.filter(item => !insertedIds.has(String(item.id)));
  return [...rest.slice(0, 1), ...inserted, ...rest.slice(1)];
};
